import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import { IRootState } from './root-state.interface';
import { RootActionTypes } from './root.actions';
import { localStorageSync } from 'ngrx-store-localstorage';
import { monitoringMetricsFeature } from '@app/monitoring/store/reducers/monitoring-metrics.reducer';
import {languageFeatureKey} from "@app/store/reducers/language.reducer";

/**
 * @description Reducer для выполнения сохранения состояния между сеансами открытия браузе для восстановления данных (настроект) выполненных пользователем
 * @param reducer
 * @returns
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: [monitoringMetricsFeature.name, languageFeatureKey], rehydrate: true })(reducer);
}

export function clearState(reducer: ActionReducer<IRootState>) {
  return function (state: IRootState | undefined, action: Action) {
    if (action.type === RootActionTypes.LOGOUT) return reducer(undefined, action);
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer[] = [clearState, localStorageSyncReducer];
